/**
 * @voltxampere/ui — SPDT toggle switch variant (Sprint 44-3, placeholder)
 *
 * PLACEHOLDER. Single-Pole Double-Throw mechanical toggle —
 * 3 terminal (common + NO + NC). Şu anki stamp 2-terminal
 * `switch` üzerinden modellenir; 3-pin SPDT engine extension
 * #4 ile aktif olur (Sprint 47+'da).
 *
 * Reference: Generic SPDT toggle (e.g. C&K 7000 series, OMRON
 * A2A). 3 A @ 250 VAC. Tipik on-off-on güç tuşu, mod seçimi,
 * polarite değiştirme.
 *
 * Engine zero-diff invariant honored — canonical `switch` engine
 * type via schemaType (Sprint 22 B1 SPDT-style stamp reuse).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { switchSymbol } from "../switch.js";
export const switchSpdt = {
    id: "switch-spdt",
    nameTr: "SPDT Toggle (3 terminal, placeholder)",
    nameEn: "SPDT Toggle (3 terminal, placeholder)",
    shortcut: "S",
    category: "passive",
    viewBox: switchSymbol.viewBox,
    terminals: switchSymbol.terminals,
    defaultLabel: "SW",
    defaultValue: "SPDT",
    schemaType: "switch",
    defaultParams: { closed: false, Ron: 1e-3, Roff: 1e9 },
    renderSVG: () => switchSymbol.renderSVG(),
};
//# sourceMappingURL=switch-spdt.js.map